import React from 'react';

import { colors } from '@/globalStyles';
import CancelIcon from '@mui/icons-material/Clear';
import ApplyIcon from '@mui/icons-material/Check';

import {
  InputWrapper,
  IconWrapper,
} from './styles';

const MobileTypingInputToolbar = (props) => {
  const {
    onApplyClick,
    onCancelClick,
  } = props;

  return (
    <InputWrapper>
      <IconWrapper onClick={() => (onCancelClick && onCancelClick())} >
        <CancelIcon />
      </IconWrapper>

      <IconWrapper onClick={() => (onApplyClick && onApplyClick())} >
        <ApplyIcon style={{ color: colors.primary }} />
      </IconWrapper>
    </InputWrapper>
  );
};

export default React.memo(MobileTypingInputToolbar);
